type Turno = {
  atividade?: string;
  terapeuta?: string;
  monitor?: string;
  tmp_atividade?: string;
  id_terap?: string;
};

type SalaIndividuais = {
  id: string;
  title: string;
  subtitle1: string;
  subtitle2: string;
  subtitle3: string;
};

export function getSalasIndividuaisFromData(
  tableSala: any[],
  tableAtividade: any[],
  tableTerap: any[],
  selectedDate: Date
): SalaIndividuais[] {
  const daysOfWeek = [
    "Domingo",
    "Segunda-Feira",
    "Terça-Feira",
    "Quarta-Feira",
    "Quinta-Feira",
    "Sexta-Feira",
    "Sábado",
  ];
  const day = daysOfWeek[selectedDate.getDay()];
  const turnoAtual = (localStorage.getItem("selectedAgenda") || "manha") as
    | "manha"
    | "tarde";

  return tableSala
    .map((sala) => {
      const turnoSala: Turno | undefined = sala.turnos?.[day]?.[turnoAtual];

      if (!turnoSala?.atividade) return null;

      const atividadeInfo = tableAtividade.find(
        (a: any) => a.atividade === turnoSala.atividade
      );

      if (atividadeInfo?.forma === "I") {
        const terapeuta =
          tableTerap.find((t: any) => t.id_terap === turnoSala.id_terap)?.nome || "";

        return {
          id: sala.n_sala,
          title: sala.n_sala,
          subtitle1: turnoSala.atividade,
          subtitle2: terapeuta,
          subtitle3: turnoSala.monitor ?? "-",
        };
      }

      return null;
    })
    .filter((sala): sala is SalaIndividuais => sala !== null);
}
